<template>
  <div id="contenedor-contrato-vista-previa">
    <v-simple-table class="transparent">
      <template v-slot:default>
        <thead>
          <tr>
            <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(concepto, index) in catalogo"
            :key="`concepto-${index}`"
            :class="colorPartida(concepto.tipo)"
          >
            <td>{{ concepto.clave }}</td>
            <!-- <td>{{ concepto.clavePadre }}</td> -->
            <td>{{ concepto.concepto }}</td>
            <td>{{ concepto.unidad }}</td>
            <td align="right">
              <template v-if="concepto.tipo > 1">{{ concepto.cantidad }}</template>
            </td>
            <td align="right">
              <template v-if="concepto.tipo > 1">{{ concepto.precioUnitario | currency }}</template>
            </td>
            <td align="right">
              <template v-if="concepto.tipo > 1">
                <v-chip color="grey lighten-2">{{ concepto.importe | currency }}</v-chip>
              </template>
            </td>
            <td class="text-right">
              <v-btn
                icon
                v-if="concepto.tipo === 2"
                @click="removerConcepto(concepto)"
                :disabled="seEstaRemoviendoConcepto"
              >
                <v-icon color="error">mdi-minus-circle</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3"></td>
            <td align="right" class="font-weight-bold">
              Importe Contratado
            </td>
            <td align="right">{{ importeContrato | currency }}</td>
            <td align="right" class="font-weight-bold">
              Importe
              Total:
            </td>
            <td align="right">
              <v-chip
                :color="
                importeDiferenciaCatalogoContrato === 0
                ? 'success'
                : 'pink darken-2'"
                dark
              >{{ importeDelCatalogo | currency }}</v-chip>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'ControCatalogoVistaPrevia',
  props: {
    catalogo: {
      type: Array,
      required: true,
    },
    importeContrato: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      seEstaRemoviendoConcepto: false,
      headers: [
        'Clave',
        'Descripción',
        'Unidad',
        'Cantidad',
        'P. Unitario',
        'Importe',
        '',
      ],
    };
  },
  methods: {
    colorPartida(tipo) {
      if (tipo === 0) return 'font-weight-bold';
      if (tipo === 1) return 'amber darken-1 white--text';
      return '';
    },
    removerConcepto(concepto) {
      this.seEstaRemoviendoConcepto = true;
      const index = this.catalogo.findIndex(
        (catalogoConcepto) => catalogoConcepto.clave === concepto.clave,
      );
      this.catalogo.splice(index, 1);
      this.seEstaRemoviendoConcepto = false;
    },
    cambiarASubpartida(concepto) {
      const nuevoConcepto = concepto;
      const index = this.catalogo.findIndex(
        (conp) => conp.clave === concepto.clave,
      );
      // const indexPartida = this.partidasCatalogo.findIndex(
      //   (partida) => partida.clave === concepto.clave,
      // );
      // const partidaAnterior = this.partidasCatalogo[indexPartida - 1];
      if (concepto.tipo === 0) {
        nuevoConcepto.tipo = 1;
        // nuevoConcepto.clavePadre = partidaAnterior.clave;
      } else {
        nuevoConcepto.tipo = 0;
        // nuevoConcepto.clavePadre = null;
      }

      this.catalogo.slice(index, 1, nuevoConcepto);
    },
  },
  computed: {
    partidasCatalogo() {
      return this.catalogo.filter((concepto) => concepto.tipo !== 2);
    },
    importeDelCatalogo() {
      return this.$ObjSumar(this.catalogo, 'importe') || 0;
    },
    importeDiferenciaCatalogoContrato() {
      return this.importeContrato - this.importeDelCatalogo;
    },
  },
};
</script>

<style lang="scss">
</style>
